import { getDomainName, isAlgoDeltaFxDomain } from "./helper_functions";
import { LOGO_TYPE } from "./key_helper";

export const APP_VERSION = "v1.2.20";
export const ENV = "LIVE";   // Change this to "BETA", "LIVE" or "LOCAL" as needed
//API CONFIGURATION
const CONFIG = {
    LIVE: {
        BASE_URL: "https://api.algodeltafx.com",
        SECRET_KEY: "ALGODELTAFX_LIVE_KEY_ADFX_USER_@2025",
    },
    BETA: {
        BASE_URL: "https://api.algodeltafx.com",
        SECRET_KEY: "ALGODELTAFX_BETA_KEYS_ADFX_USER_@2025",
    },
    LOCAL: {
        BASE_URL: "http://192.168.1.12:3000",
        SECRET_KEY: "ALGODELTAFX_LOCAL_KEY_ADFX_USER_@2025",

    }
};

export const { BASE_URL, SECRET_KEY } = CONFIG[ENV];
export const API_URL = `${BASE_URL}/api/v1`;
const WEBHOOK_FX_URL = "https://webhookfx.traderstoolkits.com/api/v1";
//  DOMAIN + BRANDING
export const domain_name_flat = getDomainName(true);
export const IS_ALGODELTAFX_DOMAIN = isAlgoDeltaFxDomain(domain_name_flat);
// WEBHOOK URL LOGIC
console.log("IS_DOMAIN", IS_ALGODELTAFX_DOMAIN);

const WEBHOOK_BASE_URL = IS_ALGODELTAFX_DOMAIN ? API_URL : WEBHOOK_FX_URL;
export const WEB_HOOK_URL = `${WEBHOOK_BASE_URL}/users/bridge/webhook/`;
export const TRADING_VIEW_BRIDGE_WEB_HOOK_URL = `${WEBHOOK_BASE_URL}/users/bridge/webhook/tradingview/`;
// STATIC PATHS
export const USER_PROFILE_PATH = `${BASE_URL}/user_profiles/`;
export const PAYMEMNT_API_URL = `${API_URL}/users/payment/makepayment`;
export const PAYMENT_BASE_URL = "http://algodeltafx.com/payment/index.php";
export const OZUYS_PAYMENT_URL = "https://ozyus.com/payment/payment.php";
// SECURITY KEY + LINKS
export const RECAPTCHA_SITE_KEY = "6Ld6zjorAAAAAPNdJtr8dlCxRzax8ScvfTdqiXIb"
export const WHATSAPP_SUPPORT_URL = "https://wa.me/9537674727"
// SOCIAL LINKS
export const INSTAGRAM_LINK = "https://www.instagram.com/algodeltafx/";
export const TWITTER_LINK = "https://x.com/AlgodeltaFx";
export const LINKEDIN_LINK = "https://www.linkedin.com/company/algodeltafx";
export const YOUTUBE_LINK = " https://www.youtube.com/@algodeltafx";
export const FACEBOOK_LINK = "https://www.facebook.com/people/AlgodeltaFx/61571065032697/";
export const API_DOCUMENTATION_URL = 'https://docs.algodeltafx.com/'
// BRAND LOGO PATHS
export const WHITE_LABEL_LOGO_PATH = `${BASE_URL}/whitelabel_images/`;
export const PORTAL_LOGO_MINI = `${WHITE_LABEL_LOGO_PATH}${domain_name_flat}_${LOGO_TYPE.VERTICAL_LOGO}.jpg`;
export const PORTAL_LOGO_LONG = `${WHITE_LABEL_LOGO_PATH}${domain_name_flat}_${LOGO_TYPE.HORIZONTAL_LOGO}.jpg`;
